import React from 'react'
import { Bot } from 'lucide-react'

const Logo = ({ className = '', showText = true, size = 'default' }) => {
  const sizes = {
    small: {
      icon: 'h-6 w-6',
      text: 'text-lg',
    },
    default: {
      icon: 'h-8 w-8',
      text: 'text-xl',
    },
    large: {
      icon: 'h-10 w-10',
      text: 'text-2xl',
    },
  }

  const currentSize = sizes[size] || sizes.default

  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo Icon */}
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-400 to-primary-600 rounded-lg blur-sm opacity-75"></div>
        <div className="relative bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg p-1.5 shadow-sm">
          <Bot className={`${currentSize.icon} text-white`} />
        </div>
      </div>

      {/* Logo Text */}
      {showText && (
        <div className="ml-3">
          <div className={`${currentSize.text} font-bold text-secondary-900 leading-tight`}>
            Triage
            <span className="text-gradient ml-1">Genius</span>
          </div>
          <div className="text-xs text-secondary-500 font-medium">
            Smart Triage for Zendesk
          </div>
        </div>
      )}
    </div>
  )
}

export default Logo